import { ItemType } from '../generated/types'

/** Item Type narrowed to event */
export type EventItemType = Omit<ItemType, 'detector'> & Required<Pick<ItemType, 'event'>>

export function isEventItemType(itemType?: ItemType): itemType is EventItemType {
    return itemType?.generationType === 'event'
}
